import { Close, DragHandle } from "@mui/icons-material";
import { Button, Drawer, Typography, useTheme } from "@mui/material";
import { Box, useMediaQuery } from "@mui/system";
import { PimoReactComponent } from "@pimo/pimo-app-builder";
export interface ConfigureDashboardSidebarState {
  configureMySpaceSidebar?: {
    isOpen?: boolean;
    entries?: {
      title: string;
      id: string;
      isVisible: boolean;
      order: number;
    }[];
  };
  onUpdate?: (
    state: {
      title: string;
      id: string;
      isVisible: boolean;
      order: number;
    }[]
  ) => void;
  onClose?: () => void;
}

export const ConfigureDashboardSidebar: PimoReactComponent<
  ConfigureDashboardSidebarState
> = ({ configureMySpaceSidebar, onUpdate, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onDragStart = (event: React.DragEvent, draggedItemId: string) => {
    event.dataTransfer.setData("draggedItemId", draggedItemId); // Store item id
  };

  const onDrop = (event: React.DragEvent, droppedItemId: string) => {
    const draggedItemId = event.dataTransfer.getData("draggedItemId");

    const newEntries = configureMySpaceSidebar?.entries?.map((entry) => {
      const droppedItem = configureMySpaceSidebar?.entries?.find(
        (e) => e.id === droppedItemId
      );
      const draggedItem = configureMySpaceSidebar?.entries?.find(
        (e) => e.id === draggedItemId
      );

      if (!droppedItem || !draggedItem) return entry;

      const droppedItemOrder = droppedItem.order;
      const draggedItemOrder = draggedItem.order;

      if (entry.id === draggedItemId) {
        return {
          ...entry,
          order: droppedItemOrder,
        };
      }

      // If the dragged item is moving down (draggedItemOrder < droppedItemOrder)
      if (draggedItemOrder < droppedItemOrder) {
        if (
          entry.id !== draggedItemId &&
          entry.order > draggedItemOrder &&
          entry.order <= droppedItemOrder
        ) {
          return {
            ...entry,
            order: entry.order - 1,
          };
        }
      }
      // If the dragged item is moving up (draggedItemOrder > droppedItemOrder)
      else if (draggedItemOrder > droppedItemOrder) {
        if (
          entry.id !== draggedItemId &&
          entry.order >= droppedItemOrder &&
          entry.order < draggedItemOrder
        ) {
          return {
            ...entry,
            order: entry.order + 1,
          };
        }
      }

      return entry;
    });

    onUpdate?.(newEntries ?? []);
  };

  const onDragOver = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const onVisibiltyChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    entryId: string
  ) => {
    const newEntries = configureMySpaceSidebar?.entries?.map((entry) => {
      if (entry.id === entryId) {
        return {
          ...entry,
          isVisible: e.target.checked,
        };
      }
      return entry;
    });

    onUpdate?.(newEntries ?? []);
  };
  return (
    <Box
      component="nav"
      sx={{
        width: {
          xs: 0,
          sm: configureMySpaceSidebar?.isOpen ? "400px" : 0,
        },
        flexShrink: { xs: 0 },
      }}
      aria-label="sidebar menu"
    >
      <aside data-testid="configureMySpaceSidebar">
        <Drawer
          variant={isMobile ? "temporary" : "persistent"}
          anchor="right"
          open={configureMySpaceSidebar?.isOpen}
          sx={{
            display: "block",

            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: "400px",
              border: "none",
              p: 2,
              gap: 2,
            },
          }}
        >
          <Box sx={{ height: "60px" }}></Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5">Configure</Typography>
            <Button onClick={onClose}>
              <Close />
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",

              gap: 1,
            }}
          >
            {configureMySpaceSidebar?.entries
              ?.sort((a, b) => a.order - b.order)
              .map((entry) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    gap: 1,
                    backgroundColor: "#f5f5f5",
                    p: 1,
                    borderRadius: "4px",
                    cursor: "grab",
                  }}
                  key={entry.id}
                  onDragStart={(e) => onDragStart(e, entry.id)}
                  onDrop={(e) => onDrop(e, entry.id)}
                  onDragOver={onDragOver}
                  draggable
                >
                  <Box
                    sx={{
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={entry.isVisible}
                      onChange={(e) => onVisibiltyChange(e, entry.id)}
                    />
                  </Box>
                  <Typography
                    sx={{
                      textAlign: "left",
                      width: "100%",
                    }}
                  >
                    {entry.title}
                  </Typography>
                  <DragHandle />
                </Box>
              ))}
          </Box>
        </Drawer>
      </aside>
    </Box>
  );
};
